export default __webpack_public_path__ + "static/media/team-bg-linear.9c512131.svg";